var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"repeating-click",rawName:"v-repeating-click",value:({ delay: 500 }),expression:"{ delay: 500 }"}],staticClass:"c-ad-slider__button",on:{"firstclick":function($event){return _vm.$emit('click')},"repeatclick":function($event){return _vm.$emit('click')}}},[_c('div',{class:_vm.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }